// extracted by mini-css-extract-plugin
export default {"root":"no_search_term-module___root___aec7affa"};